import { render } from "./StatCoffeeOrder.vue?vue&type=template&id=1e654884"
import script from "./StatCoffeeOrder.vue?vue&type=script&lang=js"
export * from "./StatCoffeeOrder.vue?vue&type=script&lang=js"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__